/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
'use strict';

var canDefineProperty = false;

if (process.env.NODE_ENV !== 'production') {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', {
      get: function get() {}
    });
    canDefineProperty = true;
  } catch (x) {// IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;